/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { createSelector } from 'reselect';
import { selectPluginsList } from '@nebula/dorado-redux-storage';

export const selectPluginsLoaded = selectPluginsList.loaded;

export const selectPluginsListType = byType => createSelector(
  selectPluginsList,
  R.filter(({ namespace, type }) => type === byType && namespace !== 'custom-validation')
);

export const filterEnabledPlugins = (plugins, enabled) =>
  R.filter(plugin => (enabled || []).indexOf(plugin.namespace) >= 0)(plugins);

const sortByCategory = R.sort((a, b) => (a === 'Home' ? -1 : b === 'Home' ? 1 : a.localeCompare(b)));

export const groupPlugins = (plugins) => {
  const groupedPlugins = R.groupBy(R.prop('category'), plugins);
  const sortedCategories = R.pipe(R.keys, sortByCategory)(groupedPlugins);
  return R.reduce((grouped, category) => {
    const categoryPlugins = R.pipe(
      R.prop(category),
      R.sortBy(R.prop('displayName'))
    )(groupedPlugins);
    return R.append(categoryPlugins, grouped);
  }, [], sortedCategories);
};
